module.exports = __webpack_public_path__ + "img/access_time-24px.4afebbd3.svg";